module.exports = __webpack_public_path__ + "static/private-calendar-10f1c00b061628af7e3483b08a8f7795.png";